import { render, staticRenderFns } from "./PackValidate.vue?vue&type=template&id=64d825a0&"
import script from "./PackValidate.vue?vue&type=script&lang=js&"
export * from "./PackValidate.vue?vue&type=script&lang=js&"
import style0 from "./PackValidate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports